import { $$, onReady, store } from '../nth-ms26-core/js/env';

// Mục menu có danh sách con (Hỗ trợ) — dùng chung cho sidebar PC và menu xổ mobile
function initSubmenus() {
  $$('[data-submenu]').forEach((btn) => {
    const item = btn.closest('.menu__item');
    btn.addEventListener('click', () => {
      const open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });
}

function initCollapse() {
  const root = document.documentElement;
  $$('[data-sidebar-toggle]').forEach((btn) => {
    const sync = () => {
      const collapsed = root.classList.contains('is-sidebar-collapsed');
      btn.setAttribute('aria-expanded', String(!collapsed));
      btn.setAttribute('aria-label', collapsed ? 'Mở rộng menu' : 'Thu gọn menu');
    };
    sync();
    btn.addEventListener('click', () => {
      root.classList.toggle('is-sidebar-collapsed');
      store.set('nth-sidebar', root.classList.contains('is-sidebar-collapsed') ? 'collapsed' : 'open');
      sync();
    });
  });
}

onReady(() => {
  initSubmenus();
  initCollapse();
});
